<template>
    <div class="homework-list-page">
      <h3 class="page-title">检查作业</h3>
        <div class="filters">
            <el-form :inline="true" :model="task_params" ref="taskFilterForm" class="demo-form-inline">
                <el-form-item class="samewidth" prop="course_id" label="班级">
                    <el-select
                    size="small"
                      v-model="task_params.course_id"
                      filterable
                      remote
                      reserve-keyword
                      loading-text="加载中..."
                      no-match-text="没有匹配的数据"
                      no-data-text="无数据"
                      placeholder="选择班级名称"
                      :remote-method="searchCourse"
                      :loading="course_loading">
                      <el-option label="全部" value=""></el-option>
                      <el-option
                        v-for="item in courseList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="samewidth" prop="lesson_id" label="授课内容">
                    <el-select
                    size="small"
                    v-model="task_params.lesson_id"
                    filterable
                    remote
                    reserve-keyword
                    loading-text="加载中..."
                    no-match-text="没有匹配的数据"
                    no-data-text="无数据"
                    placeholder="输入授课内容标题"
                    :remote-method="searchLesson"
                    :loading="lesson_loading">
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in lessonList"
                      :key="item.id"
                      :label="item.subject"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" @click="search_task">按作业查找</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" @click="clear_task">清除</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="filters">
            <el-form :inline="true" :model="homework_params" ref="homeworkFilterForm" class="demo-form-inline">
                <el-form-item class="samewidth" prop="student_name" label="学生">
                    <el-select
                    size="small"
                      v-model="homework_params.student_name"
                      filterable
                      remote
                      reserve-keyword
                      loading-text="加载中..."
                      no-match-text="没有匹配的数据"
                      no-data-text="没有数据"
                      placeholder="选择学生"
                      :remote-method="searchStudent"
                      :loading="student_loading">
                      <el-option label="全部" value=""></el-option>
                      <el-option
                        v-for="item in studentList"
                        :key="item.name"
                        :label="item.name"
                        :value="item.name">
                      </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="samewidth" prop="status" label="作业状态">
                    <el-select size="small" v-model="homework_params.status" placeholder="Select Status">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="未开始" value="unread"></el-option>
                        <el-option label="进行中" value="accepted"></el-option>
                        <el-option label="作业已完成，未做练习题" value="finished"></el-option>
                        <el-option label="已完成" value="done"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" @click="search_homework">按学生查找</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" @click="clear_homework">清除</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div v-show="searchType == 'task'">
            <el-table v-loading="loading" empty-text="无数据" :data="taskList" stripe style="width: 100%">
                <el-table-column prop="course_name" label="班级"></el-table-column>
                <el-table-column prop="lesson_subject" label="授课内容">
                  <template slot-scope="scope">
                    <el-button size="mini" type="text" @click="showLessonTask(scope.row)">{{scope.row.lesson_subject}}</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="作业名称"></el-table-column>
                <el-table-column prop="teacher_name" label="教师"></el-table-column>
                <el-table-column prop="students_count" label="学生数量" align="center">
                  <template slot-scope="scope">
                    <el-button size="mini" type="text" @click="showHomeworks(scope.row.id)">{{scope.row.students_count}}</el-button>
                  </template>
                </el-table-column>
                <el-table-column label="Drill完成情况" align="center">
                  <template slot-scope="scope">
                    {{scope.row.submitted_homeworks_count ? Math.round(scope.row.submitted_homeworks_count/ scope.row.homeworks_count * 100) : '0'}}%
                  </template>
                </el-table-column>
                <el-table-column label="Quiz完成情况" align="center">
                  <template slot-scope="scope">
                    {{scope.row.quiz_tasks_count ? Math.round(scope.row.quiz_tasks_count/ scope.row.homeworks_count * 100) : '0'}}%
                  </template>
                </el-table-column>
                <el-table-column prop="created_at" label="建立日期">
                  <template slot-scope="scope">
                    {{scope.row.created_at | dateFormat}}
                  </template>
                </el-table-column>
                <el-table-column prop="status" label="发布状态" align="center">
                  <template slot-scope="scope">
                    <el-button v-if="scope.row.status === 'started'" style="color: #67C23A" size="mini" type="text" @click="gotoPublish(scope.row)">已发布</el-button>
                    <el-button v-else size="mini" type="text" @click="gotoPublish(scope.row)">未发布</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="published_at" label="发布日期">
                  <template slot-scope="scope">
                    {{scope.row.published_at | dateFormat}}
                  </template>
                </el-table-column>
                <el-table-column prop="" label="操作" align="left">
                    <template slot-scope="scope">
                        <el-button type="warning" size="mini" plain @click="edit(scope.row)" icon="el-icon-edit"></el-button>
                        <el-button type="danger" size="mini" plain @click="remove(scope.row)" icon="el-icon-delete"></el-button>
                        <el-button type="primary" size="mini" plain @click="showHomeworks(scope.row.id)" icon="el-icon-view"></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleTaskSizeChange"
                @current-change="handleTaskCurrentChange"
                :current-page="task_params.page"
                :page-sizes="[20, 50, 100]"
                :page-size="task_params.per_page"
                layout="total, sizes, prev, pager, next, jumper"
                :total="task_total">
            </el-pagination>
        </div>
        <div v-show="searchType == 'homework'">
            <el-table v-loading="loading" empty-text="无数据" :data="dataList" stripe style="width: 100%">
                <el-table-column prop="student_name" label="学生"></el-table-column>
                <el-table-column prop="course_name" label="班级"></el-table-column>
                <el-table-column prop="lesson_name" label="授课内容"></el-table-column>
                <el-table-column prop="status" label="作业状态" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="tagsColor[scope.row.status]" size="mini">{{tagsTxt[scope.row.status]}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="score" label="成绩" align="center">
                    <template slot-scope="scope">
                        <star :stars="getScore(scope.row.results)" :maxStar="3" readonly :star-size="18"></star>
                    </template>
                </el-table-column>
                <el-table-column prop="score" label="练习题" align="center">
                    <template slot-scope="scope">
                        {{scope.row.correct_quizzes_count || 0}}/{{scope.row.quizzes_count || 0}}
                    </template>
                </el-table-column>

            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="homework_params.page"
                :page-sizes="[20, 50, 100]"
                :page-size="homework_params.per_page"
                layout="total, sizes, prev, pager, next, jumper"
                :total="homework_total">
            </el-pagination>
        </div>
        <el-dialog title="检查作业" :visible.sync="homeworksVisible">
            <el-table v-loading="homeworkLoading" empty-text="无数据" :data="homeworksList" stripe style="width: 100%">
              <el-table-column prop="student_name" label="学生"></el-table-column>
              <el-table-column prop="status" label="作业状态" align="center">
                <template slot-scope="scope">
                    <el-tag :type="tagsColor[scope.row.status]" size="mini">{{tagsTxt[scope.row.status]}}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="score" label="成绩" align="center">
                  <template slot-scope="scope">
                      <star :stars="getScore(scope.row.results)" :maxStar="3" readonly :star-size="18"></star>
                  </template>
              </el-table-column>
              <el-table-column prop="score" label="练习题" align="center">
                <template slot-scope="scope">
                    {{scope.row.correct_quizzes_count || 0}}/{{scope.row.quizzes_count || 0}}
                </template>
              </el-table-column>
          </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="homeworksVisible = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Star from '../../components/Star'

export default {
  components: { Star },
  data () {
    return {
      courseList: [],
      course_loading: false,
      homework_params: {
        // course_id: "",
        // teacher_name: "",
        student_name: '',
        class_date_gteq: '',
        class_date_lt: '',
        status: '', // waiting, submitted, finished
        page: 1,
        per_page: 20,
        order_by: '',
        fields: ''
      },
      tagsColor: {
        unread: 'error',
        accepted: 'primary',
        finished: 'warning',
        done: 'success'
      },
      tagsTxt: {
        unread: '未开始',
        accepted: '进行中',
        finished: '作业已完成，未做练习题',
        done: '已完成'
      },
      searchType: '',
      task_total: 0,
      homework_total: 0,
      dataList: [],
      loading: false,
      lesson_loading: false,
      student_loading: false,
      studentList: [],
      task_params: {
        datetime: '',
        teacher_name: '',
        lesson_id: '',
        course_id: '',
        page: 1,
        per_page: 20,
        order_by: [],
        fields: []
      },
      taskList: [],
      lessonList: [],
      homeworksVisible: false,
      homeworkLoading: false,
      homeworksList: []
    }
  },
  created () {
    this.searchCourse()
    this.searchLesson()
    this.searchStudent()

    const { course_id, lesson_id } = this.$route.query
    if (course_id) {
      this.task_params.course_id = course_id
    }
    if (lesson_id) {
      this.task_params.lesson_id = lesson_id
      this.search_task()
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'user_profile'])
  },
  watch: {
    'task_params.course_id' (value) {
      if (value) {
        this.searchLesson()
      }
    }
  },
  methods: {
    searchStudent (name) {
      this.student_loading = true
      let params = { page: 1, per_page: 20, name }
      !this.isAdmin && (params.teacher_id = this.user_profile.id)
      this.$api.students
        .list(params)
        .then(data => {
          this.studentList = data.data
          this.student_loading = false
        })
        .catch(err => {
          this.$error(err)
          this.student_loading = false
        })
    },
    getScore (results) {
      if (results.length > 0) {
        let sum = results.reduce((sum, n) => {
          return { score: sum.score + n.score }
        }).score

        let ava = sum / results.length
        if (ava < 33.3) {
          return 1
        } else if (ava < 66.7) {
          return 2
        } else {
          return 3
        }
      }
      return 0
    },
    showHomeworks (taskid) {
      this.homeworksVisible = true
      this.homeworkLoading = true
      this.$api.tasks
        .homeworks(taskid)
        .then(data => {
          this.homeworksList = data
          this.homeworkLoading = false
        })
        .catch(err => {
          this.$error(err)
          this.homeworkLoading = false
        })
    },
    searchLesson (subject) {
      this.lesson_loading = true
      if (this.task_params.course_id) {
        this.$api.courses
          .lessons({
            id: this.task_params.course_id || '',
            fields: ['id', 'subject'],
            page: 1,
            per_page: 100,
            subject
          })
          .then(data => {
            this.lessonList = data
            this.lesson_loading = false
          })
          .catch(err => {
            this.$error(err)
            this.lesson_loading = false
          })
      } else {
        this.$api.lessons
          .list({
            fields: ['id', 'subject'],
            page: 1,
            per_page: 100,
            subject
          })
          .then(data => {
            this.lessonList = data
            this.lesson_loading = false
          })
          .catch(err => {
            this.$error(err)
            this.lesson_loading = false
          })
      }
    },
    showLessonTask ({ course_id, lesson_subject }) {
      this.$router.push({
        path: '/homework/lesson',
        query: {
          course_id
        }
      })
    },
    reply (target) {
      this.$prompt('评论', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        inputPattern: /\w+/,
        inputErrorMessage: '请输入评论内容'
      })
        .then(({ value }) => {
          this.$api.homework
            .reply(target.id, {
              reply_id: 0,
              content: value
            })
            .then(data => {
              this.$success('评论成功')
            })
            .catch(err => this.$error(err))
        })
        .catch(() => {})
    },
    getHomework () {
      this.loading = true
      this.$api.homeworks
        .list(this.homework_params)
        .then(data => {
          this.homework_total = data.total
          this.dataList = data.data
          this.loading = false
        })
        .catch(err => {
          this.$error(err)
          this.loading = false
        })
    },
    getTask () {
      this.loading = true
      this.$api.tasks
        .list(this.task_params)
        .then(data => {
          this.task_total = data.total
          this.taskList = data.data
          this.loading = false
        })
        .catch(err => {
          this.$error(err)
          this.loading = false
        })
    },
    handleTaskCurrentChange (page) {
      this.task_params.page = page
      this.getTask()
    },
    handleTaskSizeChange (size) {
      this.task_params.per_page = size
      this.getTask()
    },
    searchCourse (name) {
      this.course_loading = true
      this.$api.courses
        .list({ fields: ['id', 'name'], page: 1, per_page: 100, name })
        .then(data => {
          this.courseList = data.data
          this.course_loading = false
        })
        .catch(err => {
          this.$error(err)
          this.course_loading = false
        })
    },
    handleCurrentChange (page) {
      this.homework_params.page = page
      this.getHomework()
    },
    handleSizeChange (size) {
      this.homework_params.per_page = size
      this.getHomework()
    },
    search_homework () {
      this.searchType = 'homework'
      this.getHomework()
    },
    clear_homework () {
      this.$refs['homeworkFilterForm'].resetFields()
      this.getHomework()
    },
    search_task () {
      this.searchType = 'task'
      this.getTask()
    },
    clear_task () {
      this.$refs['taskFilterForm'].resetFields()
      this.getTask()
    },
    edit (target) {
      this.$store.commit('tmp_task', target)
      this.$router.push('/homework/task/form/' + target.id)
    },
    remove (target) {
      this.$confirm(`你确认删除[${target.name}]?`, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        closeOnPressEscape: false
      })
        .then(() => {
          this.$api.tasks
            .delete(target.id)
            .then(data => {
              this.$success(`${target.name}已被删除!`)
              this.getTask()
            })
            .catch(err => {
              this.$error(err)
            })
        })
        .catch(() => {})
    },
    detail () {},
    gotoPublish ({ course_id, lesson_id, id, status }) {
      this.$router.push({ path: '/homework/publish',
        query: status === 'started' ? {
          id: course_id,
          lesson_id,
          task_id: id
        } : {
          id: course_id,
          lesson_id
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.filters .el-button{
    width: 125px;
}

.samewidth{
  display: flex;
  margin-right: 10px;
  flex-direction: column;
  align-items: flex-start;
  width: 240px;
}

</style>
